import { MicrosoftSSOModel, PluginModel } from 'api/models';
import axios from 'axios';
import { getApiUrl } from 'config/api-url';
import http from 'config/http';

export const getMicrosoftSSOAuthUrl = async ({
    type,
    userId,
    redirectUri,
}: {
    type: string;
    userId?: string;
    redirectUri: string;
}) => {
    const { data } = await http.get<{ authUrl: string }>(`${getApiUrl()}/sso/saml/microsoft/auth-url`, {
        params: { type, userId, redirectUri },
    });
    return data;
};

export const getMicrosoftSSO = async () => {
    const { data } = await http.get(`${getApiUrl()}/sso/microsoft`);

    return data ? MicrosoftSSOModel.fromObject(data) : null;
};

export const authorizeMicrosoft = async (payload: { code: string; redirectUri: string }) => {
    const { data } = await http.post(`${getApiUrl()}/sso/saml/microsoft/authorize`, {
        code: payload.code,
        redirectUri: payload.redirectUri,
    });

    return MicrosoftSSOModel.fromObject(data);
};

export const unauthorizeMicrosoftSSO = async () => {
    await http.delete(`${getApiUrl()}/sso/saml/microsoft/unauthorize`);
};

export const authenticateMicrosoft = async (payload: { code: string; redirectUri: string }) => {
    try {
        const { data } = await axios.post(`${getApiUrl()}/sso/saml/microsoft/authenticate`, {
            code: payload.code,
            redirectUri: payload.redirectUri,
        });
        return data as {
            token: string;
            hasMultipleAccounts: boolean;
        };
    } catch (err: any) {
        throw err.response || new Error('Something went wrong.');
    }
};

export const onBoardingAuthenticateMicrosoft = async (payload: { code: string; redirectUri: string }) => {
    try {
        const { data } = await axios.post(`${getApiUrl()}/sso/saml/microsoft/user-info`, {
            code: payload.code,
            redirectUri: payload.redirectUri,
        });

        return data as {
            id: string;
            email: string;
            name: string;
            dp: string;
        };
    } catch (err: any) {
        throw err.response || new Error('Something went wrong.');
    }
};

export const getMicrosoftDetails = async () => {
    const { data } = await http.get(`${getApiUrl()}/sso/microsoft/plugin-details`);

    return PluginModel.fromObject(data);
};
